import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AppInit from './app/AppInit'
import HomePage from './pages/home/page'
import DatabasePage from './pages/database/page'
import AboutDevelopersPage from './pages/aboutDevelopers/page'
import HistoryPage from './pages/history/page'
import EditSchedule from './pages/editSchedule/page'
import SchedulePage from './pages/schedule/page'

function App() {
    return (
        <>
            <AppInit />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/main" element={<SchedulePage />} />
                <Route path="/database" element={<DatabasePage />} />
                <Route path="/about" element={<AboutDevelopersPage />} />
                <Route path="/editor" element={<EditSchedule />} />
                <Route path="/history" element={<HistoryPage />} />
            </Routes>
        </>
    )
}

export default App
